<div class="toast-container fixed top-4 right-4 z-[9999] space-y-2">
  @for (toast of toasts; track toast.id) {
    <div 
      class="toast-item flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg min-w-80 max-w-md animate-slideIn"
      [ngClass]="getColorClasses(toast.type)"
    >
      <!-- Icon -->
      <svg 
        class="w-6 h-6 flex-shrink-0"
        [ngClass]="getIconColor(toast.type)"
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          stroke-linecap="round" 
          stroke-linejoin="round" 
          stroke-width="2" 
          [attr.d]="getIcon(toast.type)"
        />
      </svg>

      <!-- Message -->
      <p class="flex-1 text-sm font-medium">{{ toast.message }}</p>

      <!-- Close button -->
      <button
        type="button"
        class="flex-shrink-0 p-1 rounded hover:bg-black/5 transition-colors"
        (click)="removeToast(toast.id)"
      >
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path 
            fill-rule="evenodd" 
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" 
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
  }
</div>
